module.exports = __webpack_public_path__ + "img/cramera_des_3.58c8a584.jpg";